import React, { useRef, useState, useEffect } from "react";
import SideBar from "src/layouts/components/sidebars";
import RightSideBar from "./components/rightSidebar";
import { useSelector, useDispatch } from "react-redux";
import Header from "./components/headers";
import { setRightSideBarOpenCloseValue } from "src/thunks/goodsin";

export const WithSideBar = (props) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const [state, setState] = useState(true);
  const rightSideBarHideShowClassName = state == true ? "rightsidebar-popup-open" : "rightsidebar-popup-close";
  const rightSideBarStretchClassName = state == true ? "rightsidebar-popup-open-modal" : "rightsidebar-popup-close-modal";
  const userData = JSON.parse(localStorage.getItem("userDetails"))


  function changeData(data) {
    setState(data);
  }

  useEffect(() => {
    dispatch(setRightSideBarOpenCloseValue(state));
  }, [state])
  




  return (
    <>
      <div className="d-flex flex-column" style={{ position: "fixed", left: 0, right: 0, top: 0, bottom: 0, backgroundColor: "#f2f4f8" }}>
        <div style={{ width: "100%" }}>
          <Header RightSidebarOpenCloseFlag={state} />
        </div>

        {userData?.roles == "DepotManager" ?
          <>
            <div className="d-flex flex-row abcd" style={{ backgroundColor: "white", width: "100%" }}>
              <SideBar ref={ref} />
              {props.children}
            </div>
          </>

          :
          <>
            <div style={{ width: "100%" }} className="d-flex flex-row">
              <div className="d-flex flex-row abcd" style={{ backgroundColor: "white", width: state == true ? "84%" : "97%" }}>
                <SideBar ref={ref} />
                {props.children}
              </div>

              <div className={`${rightSideBarStretchClassName} ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""} rightSideBarNotification`}>
                <RightSideBar changeData={changeData} RightSidebarOpenCloseFlag={state} ref={ref} />
              </div>
            </div>
          </>
        }


      </div>
    </>
  );
};
